"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
var _reactRedux = require("react-redux");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// TODO: re-implement this later when we fix the coupon module.

function PromoCode(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPromoCodeField = _useState2[0],
    setPromoCodeField = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    promoCode = _useState4[0],
    setPromoCode = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    addedPromoCode = _useState6[0],
    setAddedPromoCode = _useState6[1];
  var dispatch = (0, _reactRedux.useDispatch)();
  var couponCart = (0, _reactRedux.useSelector)(function (state) {
    return state.shoppingCartReducer.couponCart;
  });
  (0, _react.useEffect)(function () {
    dispatch({
      type: 'FETCH_LINKED_COUPON_TO_CART'
    });
  }, []);
  (0, _react.useEffect)(function () {
    var _couponCart$coupon;
    if (couponCart !== null && couponCart !== void 0 && (_couponCart$coupon = couponCart.coupon) !== null && _couponCart$coupon !== void 0 && _couponCart$coupon.token) {
      var _couponCart$coupon2;
      setPromoCode(couponCart === null || couponCart === void 0 ? void 0 : (_couponCart$coupon2 = couponCart.coupon) === null || _couponCart$coupon2 === void 0 ? void 0 : _couponCart$coupon2.token);
      setAddedPromoCode(true);
      setPromoCodeField(false);
    }
  }, [couponCart]);
  var handlePromoCodeDeleted = function handlePromoCodeDeleted() {
    if (couponCart) {
      dispatch({
        type: 'REMOVE_LINKED_COUPON_TO_CART',
        id: couponCart.id
      });
    }
  };
  var handlePromoCodeAdded = function handlePromoCodeAdded() {
    dispatch({
      type: 'LINK_COUPON_TO_CART',
      model: {
        token: promoCode
      },
      onSuccess: function onSuccess() {
        return setAddedPromoCode(true);
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 10,
    alignItems: "center",
    justify: "flex-start"
  }, addedPromoCode ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Promo code :",
    defaultMessage: "Promo code :"
  })) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Add promo code",
    defaultMessage: "Add promo code"
  }))), !addedPromoCode && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 2,
    alignItems: "center",
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      return setPromoCodeField(!showPromoCodeField);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    style: {
      fontSize: '1.2rem'
    }
  }, showPromoCodeField ? 'remove' : 'add'))), addedPromoCode && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 10,
    alignItems: "center",
    justify: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    style: {
      fontWeight: 500
    },
    variant: "overline"
  }, promoCode)), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 2,
    alignItems: "center",
    justify: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      setAddedPromoCode(false);
      setPromoCode(null);
      setPromoCodeField(false);
      handlePromoCodeDeleted();
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    style: {
      fontSize: '1.2rem'
    }
  }, "delete"))))), showPromoCodeField && !addedPromoCode && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    name: "price",
    label: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Promo code",
      defaultMessage: "Promo code"
    }),
    value: promoCode,
    variant: "outlined",
    size: "small",
    fullWidth: true,
    required: true,
    onChange: function onChange(event) {
      return setPromoCode(event.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: "mt-4",
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return promoCode && handlePromoCodeAdded();
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Save code",
    defaultMessage: "Save code"
  }))))));
}
var _default = PromoCode;
exports.default = _default;